/**
 * Which refresh run this browser is watching, kept in sessionStorage.
 *
 * A React ref would be wiped by a page reload — and a reload is exactly when the question
 * matters: if the run dies while the tab is reloading, only a durable marker lets the page
 * tell "it finished" from "it vanished". Session-scoped on purpose: a new tab has no run
 * of its own to account for.
 * For Media Devoted | Created By Ciro Autiero
 */

const KEY = 'trafficpulse-catalog-refresh-watched-job';

export function rememberWatchedJob(jobId: string): void {
  try {
    sessionStorage.setItem(KEY, jobId);
  } catch {
    /* Private mode / storage disabled: the in-session behaviour just degrades. */
  }
}

export function readWatchedJob(): string | null {
  try {
    return sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function forgetWatchedJob(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* Nothing to clean up when storage is unavailable. */
  }
}
